
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * Source enum
 */
class Source {
  /**
   * Initialize enum with a given value
   * @param {Source|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof Source) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!Source}
   * @param {!Source} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Source)) {
      throw new TypeError('Instance of Source is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!Source}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!Source}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === Source.Client.value) {
      return 'Client'
    }
    if (this.value === Source.Manager.value) {
      return 'Manager'
    }
    if (this.value === Source.TradingBot.value) {
      return 'TradingBot'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!Source}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!Source}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!Source} Created enum
   */
  static fromObject (other) {
    return new Source(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
Source.Client = new Source(0 + 0)
// noinspection PointlessArithmeticExpressionJS
Source.Manager = new Source(0 + 1)
// noinspection PointlessArithmeticExpressionJS
Source.TradingBot = new Source(0 + 2)

export { Source };

/**
 * Fast Binary Encoding Source field model
 */
class FieldModelSource extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSource}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSource}
   * @param {Source=} defaults Default value, defaults is new Source()
   * @returns {!Source} Result value
   */
  get (defaults = new Source()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new Source(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSource}
   * @param {!Source} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelSource };
